// Module
var code = "<textarea class=\"form-control\" ng-model=\"model[options.key]\"></textarea>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/textarea/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;